export default "__VITE_ASSET__BWwL9201__"